export const BOOKING_STATUS = {
    UPCOMING: "upcoming",
    COMPLETED: "completed",
    AUTO_COMPLETED: "auto-completed",
    CANCELED: "canceled",
    DID_NOT_ATTEND: "dna",
};
export const STATUS_TYPE = {
    RESPONDENT: "respondent",
    BOOKING: "booking",
};
export const CUSTOM_BOOKING_STATUS_GROUPS = [
    BOOKING_STATUS.UPCOMING,
    BOOKING_STATUS.COMPLETED,
    BOOKING_STATUS.DID_NOT_ATTEND,
    BOOKING_STATUS.CANCELED,
];
export const getCustomBookingStatusGroup = (bookingStatus) => {
    if (bookingStatus === BOOKING_STATUS.AUTO_COMPLETED) {
        return BOOKING_STATUS.COMPLETED;
    }
    return bookingStatus &&
        (CUSTOM_BOOKING_STATUS_GROUPS.includes(bookingStatus) ||
            AFFILIATE_CUSTOM_BOOKING_STATUS_GROUPS.includes(bookingStatus))
        ? bookingStatus
        : null;
};
export const CLINIC_FLOW_CUSTOM_BOOKING_STATUSES = [
    { name: "Arrived", color: "#FFDD4A", systemStatus: BOOKING_STATUS.UPCOMING },
    { name: "Functional", color: "#6CBFEA", systemStatus: BOOKING_STATUS.UPCOMING },
    { name: "Ready for Doctor", color: "#8A2F7F", systemStatus: BOOKING_STATUS.UPCOMING },
    { name: "PPW Complete", color: "#E048B0", systemStatus: BOOKING_STATUS.UPCOMING },
    { name: "Pending LDAS", color: "#E3733F", systemStatus: BOOKING_STATUS.COMPLETED },
    { name: "Pending GP", color: "#E3733F", systemStatus: BOOKING_STATUS.COMPLETED },
    { name: "Ready to Send", color: "#8FD16F", systemStatus: BOOKING_STATUS.COMPLETED },
    { name: "Results Sent", color: "#B3B3B3", systemStatus: BOOKING_STATUS.COMPLETED },
];
export var ADD_ON_CHARGE_MODE;
(function (ADD_ON_CHARGE_MODE) {
    ADD_ON_CHARGE_MODE["WORKFLOW"] = "workflow";
    ADD_ON_CHARGE_MODE["INVOICE"] = "invoice";
})(ADD_ON_CHARGE_MODE || (ADD_ON_CHARGE_MODE = {}));
const red = "#FF5050";
export const affiliateBookingStatuses = {
    Unconfirmed: {
        value: "unconfirmed",
        label: "Unconfirmed",
        color: "#71e1c3",
        chartColor: "#00a1a1",
    },
    Confirmed: {
        value: "confirmed",
        label: "Confirmed",
        color: "#bcbcbc",
        chartColor: "#00c4c4",
    },
    Canceled: {
        value: "affiliate_canceled",
        label: "Canceled",
        color: red,
        chartColor: "#C0392B",
    },
    DidNotAttend: {
        value: "affiliate_dna",
        label: "Did Not Attend",
        color: "#FFA500",
        chartColor: "#E67E22",
    },
};
export const AFFILIATE_CUSTOM_BOOKING_STATUS_GROUPS = [
    affiliateBookingStatuses.Unconfirmed.value,
    affiliateBookingStatuses.Confirmed.value,
    affiliateBookingStatuses.DidNotAttend.value,
    affiliateBookingStatuses.Canceled.value,
];
export const closedBookingStatuses = [
    BOOKING_STATUS.COMPLETED,
    BOOKING_STATUS.AUTO_COMPLETED,
    BOOKING_STATUS.CANCELED,
    BOOKING_STATUS.DID_NOT_ATTEND,
    affiliateBookingStatuses.Confirmed.value,
    affiliateBookingStatuses.Canceled.value,
    affiliateBookingStatuses.DidNotAttend.value,
];
//# sourceMappingURL=booking.js.map